const commandKeys = [
    "set",
    "get",
    "push",
    "pop",
    "equal",
    "notEqual",
    "and",
    "or",
    "add",
    "sub",
    "mul",
    "div",
    "incrBy",
    "decrBy",
    "mulBy",
    "divBy",
    "if",
    "action",
    "query",
    "sAdd",
    "sUnion",
    "sInter",
    "sDiff",
    "sIsEmpty",
    "sIsMember",
    "sMembers",
    "sPop",
    "lessThan",
    "greaterThan",
    "return",
    "exists"
];

module.exports = commandKeys;
